import type { ExcursionPage } from "../slug-excursions";
import niceMonaco from "./nice-monaco";
import cannesGourdon from "./cannes-gourdon";
import antibesJuan from "./antibes-juan-les-pins";
import saintTropez from "./saint-tropez";
import rivieraItalienne from "./riviera-italienne";
import verdon from "./verdon";
import ezeLaTurbie from "./eze-la-turbie";
import saintPaul from "./saint-paul-de-vence";

export const excursionPages: ExcursionPage[] = [
  niceMonaco,
  cannesGourdon,
  antibesJuan,
  saintTropez,
  rivieraItalienne,
  verdon,
  ezeLaTurbie,
  saintPaul,
];
